module.exports = __webpack_public_path__ + "static/media/3 13 Tulleord Starter testen.f0039be2.mp3";